import i18n from './index'
import { localeApi } from '../api/localeApi'
import { resolveRouteLocale } from './routeLocale'

/** Default localStorage key i18next-browser-languagedetector caches the resolved language under
 *  (detection.caches: ['localStorage'] in ./index.ts, no custom lookupLocalStorage key set). */
const STORED_LANGUAGE_KEY = 'i18nextLng'

/** Keeps a slow/unreachable backend from delaying first paint noticeably. */
const SERVER_LOOKUP_TIMEOUT_MS = 1500

/**
 * URL-owned public routes always win over localStorage, browser language and server detection,
 * before React's first render. Only locale-neutral routes (notably `/`) use the previous first-visit
 * server suggestion / returning-visitor cache behavior.
 */
export async function bootstrapLocale(): Promise<void> {
  const routeLocale = resolveRouteLocale(window.location.pathname)
  if (routeLocale) {
    await i18n.changeLanguage(routeLocale)
    document.documentElement.lang = routeLocale
    return
  }
  if (localStorage.getItem(STORED_LANGUAGE_KEY)) return
  try {
    const { language } = await Promise.race([
      localeApi.get(),
      new Promise<never>((_, reject) => {
        setTimeout(() => reject(new Error('locale lookup timed out')), SERVER_LOOKUP_TIMEOUT_MS)
      }),
    ])
    await i18n.changeLanguage(language)
  } catch {
    // Backend unreachable/slow - navigator-based detection from i18n.init() remains in effect.
  }
}
